export default "__VITE_ASSET__2ceecb9a__"